import { createContext } from "react";
import useContractSummariesByLotId from "../hooks/data/useContractSummariesByLotId";

export interface IContractSummariesContext extends ReturnType<typeof useContractSummariesByLotId> {

};

const ContractSummariesContext = createContext<IContractSummariesContext>({
    data: undefined,
    error: undefined,
    loading: true,
    validating: true,
    mutate: async () => { return undefined },
    refresh: async () => { return undefined },
});

export default ContractSummariesContext